import styled, { css } from 'styled-components';
import { variables } from 'components/theme';
import {
  itemMainBackgroundColor,
  playerTextColor,
  SVGColors
} from 'utils/theme';

const commonStyles = css`
  margin-left: 28px;
  margin-right: 28px;

  @media screen and (max-width: 768px) {
    margin-left: 14px;
    margin-right: 14px;
  }
`;

const flexBetweenCenter = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Wrapper = styled.div`
  ${variables.fonts.overpassMonoRegular}
  color: ${playerTextColor};
  position: fixed;
  top: ${({ embed }) => (embed ? '0' : '56px')};
  left: 0;
  right: 0;
  background: ${itemMainBackgroundColor};
  z-index: 19;

  svg {
    fill: ${playerTextColor};
    display: block;
    cursor: pointer;
    height: 24px;
    width: 24px;
  }
`;

export const MediaPlayer = styled.div`
  width: 100%;
  padding: 7px 0;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.16);
`;

export const MediaContent = styled.div`
  ${flexBetweenCenter}
`;
export const PlayPause = styled.div`
  ${commonStyles}
`;
export const VideoPlayPause = styled.div`
  transition: all 0.8 ease-in-out;
  cursor: pointer;
  svg {
    fill: white !important;
    display: block;
    cursor: pointer;
    height: 24px;
    width: 24px;
  }
`;

export const ToggleIcons = styled.img``;

export const Loader = styled.div`
  ${commonStyles}
`;

export const Controls = styled.div`
  flex-grow: 1;
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    display: block;
  }

  p {
    color: ${playerTextColor};
  }

  a {
    color: inherit;
  }
`;

export const Slider = styled.div`
  position: relative;
`;

export const Thumb = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  height: 4px;
  background: transparent;
  cursor: pointer;

  :focus {
    outline: none;
  }

  // FOR WEBKIT BROWSERS - CHROME, OPERA AND SAFARI
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    pointer-events: auto;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    height: 12px;
    width: 12px;
    border-radius: 8px;
    background: ${variables.colors.grey12};
    cursor: pointer;
  }

  // FOR MOZILLA FIREFOX
  ::-moz-range-thumb {
    -moz-appearance: none;
    pointer-events: auto;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    height: 12px;
    width: 12px;
    border: none;
    border-radius: 8px;
    background: ${variables.colors.grey12};
    cursor: pointer;
  }
`;

export const Track = styled.progress`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;

  width: 100%;
  height: 4px;
  position: absolute;
  top: 14px;
  left: 0;
  z-index: -1;
  border-radius: 2px;
  background: ${variables.colors.grey12};

  // FOR WEBKIT BROWSERS - CHROME, OPERA AND SAFARI
  ::-webkit-progress-bar {
    background: ${variables.colors.grey12};
  }

  ::-webkit-progress-value {
    background: #ffec00;
  }

  // FOR MOZILLA FIREFOX
  ::-moz-progress-bar {
    background: #ffec00;
  }
`;

export const Queue = styled.div`
  margin-left: 56px;
  margin-right: 35px;

  @media screen and (max-width: 768px) {
    margin-left: 0;
    margin-right: 14px;
  }
`;

export const CountDownWrapper = styled.div`
  padding: 0px 63px;
  background-color: ${variables.colors.grey23};
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: auto;
  height: auto;
  min-height: 550px;
  border-radius: 14px;
  color: ${variables.colors.white};
  margin-bottom: 110px;

  span {
    color: ${variables.colors.yellow1};
  }

  div {
    line-height: 1.6;
  }

  @media screen and (max-width: 768px) {
    padding: 24px 26px 14px;
    margin-bottom: 87px;
    min-height: 240px;
    border-radius: 0px;

    h2,
    span {
      font-size: 15px;
    }

    h5 {
      font-size: 12px;
    }
  }
`;

export const H2 = styled.h2`
  color: ${variables.colors.yellow1};

  @media screen and (max-width: 768px) {
    font-size: 15px;
  }
`;

export const H1 = styled.h1`
  font-size: 3rem;

  @media screen and (max-width: 768px) {
    font-size: 30px;
  }
`;

export const VideoWrapper = styled.div`
  margin-top: 21px;
  height: 100%;

  @media screen and (max-width: 768px) {
    /* margin-top: 56px; */
  }

  video {
    border-radius: 8px;
    background-color: ${variables.colors.grey23};
    padding: ${props =>
      props.match.path === `/stream/:slug` ? '28px' : '0px'};

    @media screen and (max-width: 768px) {
      padding: 0px;
      border-radius: 0px;
    }
  }

  video::-webkit-media-controls {
    display: none;
  }

  iframe {
    border-radius: 8px;

    @media screen and (max-width: 768px) {
      border-radius: 0px;
    }
  }
`;

export const VideoControls = styled.div`
  position: relative;
  flex-grow: 1;
  z-index: 5;
  background: transparent;
  bottom: 100px;
  margin: 0px 21px;

  input {
    // FOR WEBKIT BROWSERS - CHROME, OPERA AND SAFARI
    ::-webkit-slider-thumb {
      -webkit-appearance: none;
      margin-top: 2px;
      visibility: hidden;
      pointer-events: auto;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      height: 12px;
      width: 12px;
      border-radius: 50%;
      background: ${variables.colors.grey12};
      cursor: pointer;
    }

    // FOR MOZILLA FIREFOX
    ::-moz-range-thumb {
      -moz-appearance: none;
      pointer-events: auto;
      visibility: hidden;
      margin-top: 2px;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      height: 12px;
      width: 12px;
      border: none;
      border-radius: 8px;
      background: ${variables.colors.grey12};
      cursor: pointer;
    }
  }

  progress {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 1px solid transparent;
    border-radius: 8px;
    height: 7px;
    background: rgba(255, 255, 255, 0.3);
    cursor: pointer;

    ::-webkit-progress-bar {
      background: transparent;
      border-radius: 5px;
    }

    ::-webkit-progress-value {
      background: #ffec00;
      border-radius: 5px;
    }

    // FOR MOZILLA FIREFOX
    ::-moz-progress-bar {
      background: #ffec00;
      border-radius: 5px;
    }
  }
`;

export const VideoTime = styled.div`
  display: flex;
  justify-content: space-between;
  color: white;
`;

export const ControlOptions = styled.div`
  margin-top: 7px;
  ${flexBetweenCenter}
`;

export const CtrlOptionsIcons = styled.div`
  ${flexBetweenCenter};
  transition: all 0.3 ease-in-out;

  svg {
    cursor: pointer;
    height: 24px;
    width: 24px;
    margin-right: 14px;

    &:hover path {
      opacity: 1;
    }
  }

  svg path {
    fill: ${SVGColors};
  }

  svg:nth-child(-n + 3) {
    display: none;
  }

  @media screen and (max-width: 768px) {
    svg path {
      fill: ${SVGColors};
      opacity: 1;
    }
  }
`;
